import React from 'react';

import ModalInterior from '@alltrails/shared/components/modals/ModalInterior';
import ModalBackground from '@alltrails/shared/components/modals/ModalBackground';
import successUpload from 'images/icons/share/filled@2x.png';
import CustomProvider from 'components/CustomProvider';
import ProgressDialog from 'components/shared/ProgressDialog';

import * as styles from './styles/styles.module.scss';

type Variant = 'creating-alert' | 'saving-alert' | 'created-alert' | 'created-alert-button' | 'saved-alert' | 'error';
type AlertsDrawerModalProps = {
  variant: Variant;
  setVariant: (variant: Variant) => void;
  isMounted: boolean;
  closeModal: () => void;
  onClick: () => void;
};

const AlertsDrawerModal = ({ variant, setVariant, isMounted, closeModal, onClick }: AlertsDrawerModalProps) => (
  <CustomProvider>
    {variant === 'created-alert-button' ? (
      <ModalBackground closeModal={closeModal}>
        <ModalInterior
          closeModal={closeModal}
          isMounted={isMounted}
          baseCtas={{ primaryCta: { text: 'View Alert', onClick, testId: 'alert-create-modal-view-alert' } }}
        >
          <div className={styles.content}>
            <img src={successUpload} alt="Alert created!" />
            Alert created!
          </div>
        </ModalInterior>
      </ModalBackground>
    ) : (
      <ProgressDialog variant={variant} updateProgressDialog={setVariant} downloadLink={null} isMobileWidth={false} openPdf={null} />
    )}
  </CustomProvider>
);

export default AlertsDrawerModal;
